import { TypeSchema, areTableNamesEqual, getTableName } from "./description";
import { TableName } from "../database-strings";
import {
    SourceMetadata,
    AppDescription,
    getSourceMetadata,
    getGoogleSheetsSourceMetadata,
} from "../components/SerializedApp";
import { assert, isArray } from "../Support";

export function renameTableInSchema(schema: TypeSchema, tableName: TableName, newName: string): TypeSchema {
    const { tables } = schema;
    const newTables = tables.map(t => {
        if (!areTableNamesEqual(getTableName(t), tableName)) return t;

        return { ...t, sheetName: newName };
    });
    return { ...schema, tables: newTables };
}

// `false` means Google Sheets
export function getMaybeSourceMetadataForTable(
    appOrMetadata: AppDescription | readonly SourceMetadata[],
    tableName: TableName | false
): SourceMetadata | undefined {
    if (!isArray(appOrMetadata)) {
        appOrMetadata = getSourceMetadata(appOrMetadata);
    }

    if (tableName !== false) {
        for (const m of appOrMetadata) {
            if (m.type === "Native table" && areTableNamesEqual(tableName, m.tableName)) {
                return m;
            }
        }
    }

    return getGoogleSheetsSourceMetadata(appOrMetadata);
}

// `false` means Google Sheets
export function getSourceMetadataForTable(
    appOrMetadata: AppDescription | readonly SourceMetadata[],
    tableName: TableName
): SourceMetadata;
export function getSourceMetadataForTable(
    appOrMetadata: AppDescription | readonly SourceMetadata[],
    tableName: TableName | false
): SourceMetadata | undefined;
export function getSourceMetadataForTable(
    appOrMetadata: AppDescription | readonly SourceMetadata[],
    tableName: TableName | false
): SourceMetadata | undefined {
    const metadata = getMaybeSourceMetadataForTable(appOrMetadata, tableName);
    if (metadata === undefined) {
        assert(tableName === false, `No such table ${JSON.stringify(tableName)}`);
    }
    return metadata;
}
